// This component should be used as the container for any slot that appears on the calendar.
// This component will render the children in the correct position on the calendar according to the supplied start time and duration.
import moment, { Moment } from "moment-timezone";
import { useEffect, useState } from "react";

type ScheduleSlotProps = {
  startTime: Moment;
  dayOfWeek: number;
  durationInHours?: number;
  children: React.ReactNode;
  viewingDate: Moment;
  cypressSelector?: string;
};

export default function ScheduleSlotContainer(props: ScheduleSlotProps) {
  const {
    dayOfWeek,
    startTime,
    durationInHours = 1,
    viewingDate,
    cypressSelector,
  } = props;

  const [currentDay, setCurrentDay] = useState(viewingDate.day() + 1);
  useEffect(() => {
    setCurrentDay(viewingDate.day() + 1);
  }, [viewingDate]);
  return (
    <li
      data-cy={cypressSelector}
      className={`relative mt-px col-start-1  z-auto sm:col-start-${dayOfWeek} ${
        currentDay === dayOfWeek ? "flex" : "hidden sm:flex"
      }`}
      // There is a gap at the top of the calendar that is why we add 2.
      style={{
        gridRow: `${2 + calculateSlotOffset(startTime)} / span 1`,
      }}
    >
      {/* This span is only to force tailwind to include some classes that is added dynamically during runtime */}
      <span className="hidden  sm:col-start-1 sm:col-start-2 sm:col-start-3 sm:col-start-4 sm:col-start-5 sm:col-start-6 sm:col-start-7" />
      {props.children}
    </li>
  );
}
function calculateSlotOffset(startTime: Moment): number {
  let offset = startTime.hour();
  return offset;
}
